
<section class="main-home">
    <!-- *ngIf="isData" -->
    <div class="wrapper">
        <comp-video></comp-video>
        <main-section-home></main-section-home>
        <statistics-home2></statistics-home2>
        <portfolio-section-home2></portfolio-section-home2>
        <staffs-home2></staffs-home2>
        <our-clients></our-clients>
    </div>
    <!-- <app-loader [loader]='isLoading'></app-loader> -->
</section>





<!-- advertise -->
<div class="home-advertise-component">

    <app-advertise-home 
    [img_url_en]="'../../assets/images/advertise.jpeg'" 
    [img_url_ar]="'../../assets/images/advertise.jpeg'" 
    [img_url_mobile_en]="'../../assets/images/advertise.jpeg'" 
    [img_url_mobile_ar]="'../../assets/images/advertise.jpeg'" 
    [srcPage]="'home'"
    >
    </app-advertise-home>

</div>
  